import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import CardEmpty from "Utils/Cards/CardEmpty";
import { useCorrelativoInicialPallet } from "../../hooks/useCorrelativoInicialPallet";

const RUTA_CONFIGURACION =
    "/produccion-bodega/inventario?tab=INVENTARIO_INICIAL";

const NOMBRE_PANTALLA = "Bodega producción / Inventario / Inventario inicial";

// Las pantallas que registran movimientos no se pueden usar mientras no exista
// el correlativo inicial de pallets: sin él la numeración del año arrancaría
// repitiendo los números de los pallets creados fuera del sistema.
// Mientras responde el servidor se asume configurado, para no interrumpir el
// caso normal con un bloqueo que aparece y desaparece
const BloqueoCorrelativoInicialBase = ({
    children,
    accesoConfiguracion,
    history,
}) => {
    const { configurado } = useCorrelativoInicialPallet();

    if (configurado) return children;

    return (
        <CardEmpty>
            <div className="text-center py-5">
                <h4 className="mb-3">
                    Falta configurar el correlativo inicial de pallets
                </h4>
                <p className="mb-0 text-sm">
                    Antes de registrar movimientos hay que indicar desde qué
                    número se numerarán los pallets creados en el sistema.<br/> Lo
                    configura bodega de producto terminado, en{" "}
                    {accesoConfiguracion ? (
                        <Link to={RUTA_CONFIGURACION}>{NOMBRE_PANTALLA}</Link>
                    ) : (
                        <b>{NOMBRE_PANTALLA}</b>
                    )}
                    .
                </p>

                <div className="d-flex justify-content-center mt-4 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={() => history.goBack()}
                    >
                        Regresar
                    </button>
                </div>
            </div>
        </CardEmpty>
    );
};

// El enlace solo se muestra a quien ya tiene acceso al inventario de bodega,
// que es el mismo permiso con el que aparece esa opción en el menú; a los demás
// roles se les dice dónde se configura, sin llevarlos a un módulo que no les
// corresponde
const mapStateToProps = (state) => {
    const usuario = state.login ? state.login.me : null;

    const permisos = usuario && usuario.rol_usuario ? usuario.rol_usuario : {};

    return {
        accesoConfiguracion: Boolean(permisos.prod_bodega_cierres_inventario),
    };
};

export const BloqueoCorrelativoInicial = withRouter(
    connect(mapStateToProps)(BloqueoCorrelativoInicialBase),
);

// Envuelve una pantalla para el router. El resultado se guarda por componente,
// porque devolver uno nuevo en cada render volvería a montar la pantalla
const pantallas = new Map();

export const conCorrelativoInicial = (Pantalla) => {
    if (!pantallas.has(Pantalla)) {
        pantallas.set(Pantalla, (props) => (
            <BloqueoCorrelativoInicial>
                <Pantalla {...props} />
            </BloqueoCorrelativoInicial>
        ));
    }

    return pantallas.get(Pantalla);
};
